/*
 * Module for attributes
 */

define([
  "marionette",
  "backbone",
  "underscore",
  "messaging/messenger",
  "modules/shared/attributes/attributesView",
  "modules/shared/selectableList/selectableListModule",
  "./attributeList/attributeListModule",
  "./attributeInfo/attributeInfoModule",
], function (
  Marionette,
  Backbone,
  _,
  Messenger,
  AttributesView,
  SelectableListModule,
  AttributeListModule,
  AttributeInfoModule,
) {
  var AttributesController = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "attributes";
      this.namespace = options.namespace;
      this.region = options.region;
    },

    show: function ({ responseId } = {}) {
      this.layout = new AttributesView.attributesLayout();

      this.attributeList = this.addSubModule(
        new AttributeListModule({
          namespace: this.namespace,
          region: this.layout.attributeList,
        }),
      );
      this.attributeValue = this.addSubModule(
        new AttributeInfoModule({
          namespace: this.namespace,
          region: this.layout.attributeValue,
          responseId: responseId,
        }),
      );

      this.showRegion(this.layout);
      this._showSubViews();
    },

    focus: function () {
      if (this.isOpen && this.attributeList) {
        this.attributeList.focus();
      }
    },

    setSelected: function (attributeId) {
      // if attribute selected in editor, select that in list, and show value
      if (!_.isUndefined(attributeId)) {
        this.attributeList.setSelected(attributeId);
      }
    },

    _showSubViews: function () {
      this.attributeList.show();
    },
  });

  return AttributesController;
});
